import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import moment from 'moment';

import '../forms/form.css';
import { DateInput } from '../forms/FormItems';
import { ExpandIconButton } from './PageComponents';
import { formatDate } from '../functions';

/** Группа чекбоксов со списком строго в формате [{ Id, Name }] */
export class CheckBoxGroup extends Component {
	constructor(props) {
		super(props);
		this.state = { IsOpen: _.isUndefined(props.DefaultOpen) ? true : props.DefaultOpen };
	}

	componentDidUpdate() { this.setIndeterminate(); }

	setInput = (input) => {
		this.input = input;
		this.setIndeterminate();
	}

	/** Состояние общей галки: выключена, включена или выбрана часть группы */
	getCheckedState = () => {
		const ids = _.map(this.props.List || [], "Id"),
			checkedIds = _.intersection(ids, this.props.Value || []);

		if (_.isEmpty(checkedIds)) return false;
		if (checkedIds.length === ids.length) return true;
		return null;
	}

	setIndeterminate = () => {
		if (this.input) {
			this.input.checked = this.getCheckedState();
			this.input.indeterminate = _.isNull(this.getCheckedState());
		}
	}

	/** Добавление или удаление всех значений текущей группы */
	onAllChange = (event) => {
		if (!this.props.onChange) return;

		const ids = _.map(this.props.List || [], "Id"),
			value = this.props.Value || [],
			result = event.target.checked
				? _.uniq(_.concat(value, ids))
				: _.filter(value, (id) => _.indexOf(ids, id) === -1);

		this.props.onChange(result, this.props.Id);
	}

	/** Добавление или удаление одного значения */
	onChange = (event) => {
		if (!this.props.onChange) return;

		const value = this.props.ParseType === "number"
				? parseInt(event.target.value, 10)
				: event.target.value,
			result = event.target.checked
				? _.uniq(_.concat(this.props.Value || [], value))
				: _.without(this.props.Value || [], value);

		this.props.onChange(result, this.props.Id);
	}

	/** Сворачивание и разворачивание значений группы */
	toggle = () => { this.setState({ IsOpen: !this.state.IsOpen }); }

	render() {
		const list = this.props.List || [],
			value = this.props.Value || [];

		const groupTitle = this.props.Title && this.props.CanGroup ?
			<label className="title" title={this.props.Title}>
				<input
					type="checkbox"
					name="all"
					disabled={this.props.Disabled}
					readOnly={false}
					ref={this.setInput}
					onChange={this.onAllChange}
				/>
				{this.props.Title}
			</label> : null;

		return (
			<div className={"form-row " + (this.props.CanGroup ? " checkGroup " : "")
				+ (this.props.Title && this.props.CanGroup ? "hasCheckBoxGroupHeader " : "")
				+ (this.props.CanToggle ? (this.state.IsOpen ? "open " : "close ") : "")
				+ (this.props.RowClass || "")}>
				{this.props.Title && !this.props.CanGroup &&
					<label className="focused" title={this.props.Title}>{this.props.Title}</label>
				}
				{groupTitle && !this.props.CanToggle && groupTitle}
				{groupTitle && this.props.CanToggle &&
					<div className="checkBoxGroupHeader">
						{groupTitle}
						<ExpandIconButton IsOpen={this.state.IsOpen} onClick={this.toggle} />
					</div>
				}
				{(!this.props.CanToggle || this.state.IsOpen) && !this.props.HideItems &&
				<div className="form-input">
					{list.map((item) => {
						const title = item.Name + (item.Description ? " – " + item.Description : "");

						return(
							<label className="checkGroupLabel" key={item.Id} title={title}>
								<input
									type="checkbox"
									name={this.props.Id + "_" + item.Id}
									value={item.Id}
									checked={_.indexOf(value, item.Id) !== -1}
									disabled={item.Disabled || this.props.Disabled}
									readOnly={false}
									onChange={this.onChange}
								/>
								{item.Name}
							</label>
						)
					})}
				</div>
				}
				{(!this.props.CanToggle || this.state.IsOpen) && this.props.children}
			</div>
		)
	}
}
CheckBoxGroup = observer(CheckBoxGroup);

/** Группа кнопок для выбора одного значения */
export class ButtonSelectGroup extends Component {
	/** Передача ID выбранного доступного значения */
	onChange = (item) => {
		if (this.props.Disabled || item.Disabled || this.props.Value === item.Id) return false;
		if (this.props.onChange) this.props.onChange(item.Id, this.props.Id);
	}

	render () {
		const title = this.props.Title;
		return(
			<div className={"form-row " + (this.props.RowClass || "")}>
				{title && <label className="focused" title={title}>{title}</label>}
				<div className="form-input buttonSelectGroup">
					{_.map(this.props.List || [], (item) =>
						<button
							type="button"
							className={(this.props.Value === item.Id ? "active " : "") + (item.Style || "")}
							data-id={item.Id}
							disabled={this.props.Disabled || item.Disabled}
							key={"b" + item.Id}
							onClick={() => this.onChange(item)}
						>
							{item.Name}
						</button>
					)}
				</div>
			</div>
		)
	}
}

export class DatePreset extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Preset : this.props.Preset ? this.props.Preset : "month"
		}
	}
	setPreset = (preset) => {
		var item = _.find(this.Presets, { Id : preset });
		if (_.isUndefined(item)) return false;

		this.props.onChange(item.DateFrom, "DateFrom");
		this.props.onChange(item.DateTo, "DateTo");
		this.setState({ Preset : preset });
	}

	/** Ручное изменение даты снимает выбранный пресет и передаёт значение наружу */
	onDateChange = (value, id) => {
		this.setState({ Preset : undefined });
		this.props.onChange(value, id);
	}

	/** Список доступных периодов с рассчитанными границами дат */
	get Presets () {
		const today = moment(),
			dateTo = formatDate(today, "r");

		return [
			{ Id : "today", Name : "Сегодня", DateFrom : dateTo, DateTo : dateTo },
			{ Id : "yesterday", Name : "Вчера", DateFrom : formatDate(today.clone().subtract(1, "d"), "r"), DateTo : formatDate(today.clone().subtract(1, "d"), "r") },
			{ Id : "week", Name : "Неделя", DateFrom : formatDate(today.clone().subtract(1, "w"), "r"), DateTo : dateTo },
			{ Id : "month", Name : "Месяц", DateFrom : formatDate(today.clone().subtract(1, "M"), "r"), DateTo : dateTo }
		];
	}

	render() {
		return(
			<div className="dates">
				<ButtonSelectGroup
					Id="DatePreset"
					List={this.Presets}
					RowClass="datepreset"
					Value={this.state.Preset}
					onChange={this.setPreset}
				/>
				<div className='inputs'>
					<DateInput
						Id="DateFrom"
						Title="Начало отчета"
						Value={this.props.DateFrom}
						MaxDate={this.props.MaxDate}
						IsClearable={!_.isUndefined(this.props.IsClearable) ? this.props.IsClearable : true}
						onChange={this.onDateChange}
					/>
					<DateInput
						Id="DateTo"
						Title="Конец отчета"
						Value={this.props.DateTo}
						MaxDate={this.props.MaxDate}
						IsClearable={!_.isUndefined(this.props.IsClearable) ? this.props.IsClearable : true}
						onChange={this.onDateChange}
					/>
				</div>
			</div>
		)
	}
}
